const timerMessages = {
  day: ['timerMessages>>day', 'Dzień'],
  days: ['timerMessages>>days', 'Dni'],
}

export default timerMessages;
